import { render, staticRenderFns } from "./Expediente.vue?vue&type=template&id=6c059ac7&scoped=true&"
import script from "./Expediente.vue?vue&type=script&lang=js&"
export * from "./Expediente.vue?vue&type=script&lang=js&"
import style0 from "./Expediente.vue?vue&type=style&index=0&id=6c059ac7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c059ac7",
  null
  
)

export default component.exports